import { title } from "process";
import React from "react";
import style from "../assets/style.module.css";
import { Quiz } from "./Quiz";

interface QuizMenuInterface {
  data: any;
  title?: string;
}
export const QuizMenu: React.FC<QuizMenuInterface> = (props) => {
  return (
    <div className={` ${style.mainX}`}>
      {props?.data?.length !== 0 ? (
        props?.data?.map((e: any) => <Quiz data={e} title={title}></Quiz>)
      ) : (
        <></>
      )}
    </div>
  );
};
export default QuizMenu;
